import React from 'react';

import {add} from 'date-fns/add';
import {differenceInMilliseconds} from 'date-fns/differenceInMilliseconds';
import {startOfDay} from 'date-fns/startOfDay';

const useDayCycle = () => {
  const [date, setDate] = React.useState(new Date());

  React.useEffect(() => {
    const difference = differenceInMilliseconds(startOfDay(add(date, {days: 1})), date);

    const timeout = window.setTimeout(() => setDate(new Date()), difference);

    return () => {
      window.clearTimeout(timeout);
    };
  }, [date]);

  return React.useMemo(() => startOfDay(date), [date]);
};

export default useDayCycle;
